import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from 'codex-lib';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import { ParticipantTypeEnum } from 'src/app/enum/participant.enum';
import { Signatory } from 'src/app/envelope/model/signatory';
import { SignatoryFilter } from 'src/app/envelope/model/signatory-filter';
import { TableObserverUser } from 'src/app/envelope/model/table-observer-user';
import { TableResponsibleUser } from 'src/app/envelope/model/table-responsible-user';
import { TableAuthorizerUser } from 'src/app/envelope/model/tableAuthorizerUser';
import { TableSignUser } from 'src/app/envelope/model/tableSignUser';
import { SignatoryService } from 'src/app/envelope/services/signatory.service';
import { Authorizer } from 'src/app/model/authorizer';
import { Observer } from 'src/app/model/observer';
import { Responsible } from 'src/app/model/responsible';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { LanguageUtil } from 'src/app/util/language-util';
import { WhatasappSettingsService } from 'src/app/modules/settings/services/whatsapp-settings.service';

@Component({
  selector: 'app-participant-modal',
  templateUrl: './participant-modal.component.html',
  styleUrls: ['./participant-modal.component.scss'],
})
export class ParticipantModalComponent implements OnInit {
  @Output() closeModalClick = new EventEmitter();
  @Output() submitModalClick = new EventEmitter<{ data: any, isEdited: boolean }>();
  @Output() addOrUpdateParticipant = new EventEmitter();

  @Input() participantTypeInput: ParticipantTypeEnum;
  @Input() enableEditContact: boolean;
  @ViewChild('addSignatoryModal') addSignatoryModal!: TemplateRef<any>;
  @ViewChild('addAuthorizerModal') addAuthorizerModal!: TemplateRef<any>;
  @ViewChild('addObserverModal') addObserverModal!: TemplateRef<any>;
  @ViewChild('addResponsibleModal') addResponsibleModal!: TemplateRef<any>;
  @ViewChild('confirmDeleteModal') confirmDeleteModal!: TemplateRef<any>;

  tableUser: TableSignUser;
  tableAuthorizerUser: TableAuthorizerUser;
  tableObserverUser: TableObserverUser;
  tableResponsibleUser: TableResponsibleUser;
  searchText = '';
  titleModal = '';
  subTitle = '';
  headerTextConfirmDeleteModal = '';
  questionTextConfirmDeleteModal = '';
  messageTextConfirmDeleteModal = '';
  userToEditSignatory: Signatory;
  userToEditAuthorizer: Authorizer;
  userToEditObserver: Observer;
  userToEditResponsible: Responsible;
  activeModal: NgbActiveModal;
  tableHeaderCheckboxState: CheckboxState;
  public loading = false;
  isUpdate: boolean;
  filter: SignatoryFilter;
  participantTypeEnum = ParticipantTypeEnum;
  idsToRemove: number[] = [];
  pageSize: number;
  pageLimit: number;
  config: any;
  elements: Array<any> = [];
  elementsSelecteds: Array<any> = [];
  signatoryEdited: Array<any> = [];
  showSSN: boolean = true;
  showTelephone: boolean = true;
  showSignatureType: boolean = true;
  showSubscriberType: boolean = true;
  isSendWhatsapp: boolean = false;

  constructor(
    private translateService: TranslateService,
    private modalService: NgbModal,
    private signatoryService: SignatoryService,
    private googleAnalyticService: AnalyticsService,
    private layoutService: LayoutService,
    private whatsappSettingsService: WhatasappSettingsService
  ) {
    this.tableUser = new TableSignUser(translateService);
    this.tableAuthorizerUser = new TableAuthorizerUser();
    this.tableObserverUser = new TableObserverUser();
    this.tableResponsibleUser = new TableResponsibleUser();
    this.filter = new SignatoryFilter();
  }

  async ngOnInit() {
    this.loading = true;
    
    this.isSendWhatsapp = await this.whatsappSettingsService
      .getSendingByWhatsapp()
      .toPromise();

    Object.assign(this.filter, {
      skip: 0,
      take: 100,
      obfuscateSsn: false,
      obfuscateMail: false,
      obfuscateTelephone: false
    });

    this.pageSize = 0;
    this.pageLimit = 100;

    const configMap = {
      [ParticipantTypeEnum.Signatory]: {
        title: 'envelope.signatory.modalAdd.headerText',
        subtitle: 'envelope.signatory.modalAdd.descriptionText',
        confirmHeader: 'envelope.signatory.confirm-delete-modal.headerText',
        confirmQuestion: 'envelope.signatory.confirm-delete-modal.questionText',
        confirmMessage: 'envelope.signatory.confirm-delete-modal.messageText',
        showSsn: LanguageUtil.isCurrentLanguagePT(this.translateService.currentLang),
        showTelephone: this.isSendWhatsapp,
        showSignatureType: true,
        showSubscriberType: true,
        search: () => this.searchSignatories(this.searchText, null)
      },
      [ParticipantTypeEnum.Authorizer]: {
        title: 'envelope.authorizer.modalAdd.headerText',
        subtitle: 'envelope.authorizer.modalAdd.descriptionText',
        confirmHeader: 'envelope.authorizer.confirm-delete-modal.headerText',
        confirmQuestion:
          'envelope.authorizer.confirm-delete-modal.questionText',
        confirmMessage: 'envelope.authorizer.confirm-delete-modal.messageText',
        showSsn: LanguageUtil.isCurrentLanguagePT(this.translateService.currentLang),
        showTelephone: this.isSendWhatsapp,
        showSignatureType: false,
        showSubscriberType: false,
        search: () => this.searchSignatories(this.searchText, null),
      },
      [ParticipantTypeEnum.Observer]: {
        title: 'envelope.observer.modalAdd.headerText',
        subtitle: 'envelope.observer.modalAdd.descriptionText',
        confirmHeader: 'envelope.observer.confirm-delete-modal.headerText',
        confirmQuestion: 'envelope.observer.confirm-delete-modal.questionText',
        confirmMessage: 'envelope.observer.confirm-delete-modal.messageText',
        showSsn: false,
        showTelephone: this.isSendWhatsapp,
        showSignatureType: false,
        showSubscriberType: false,
        search: () => this.searchSignatories(this.searchText, null),
      },
      [ParticipantTypeEnum.Responsible]: {
        title: 'envelope.responsible.modalAdd.headerText',
        subtitle: 'envelope.responsible.modalAdd.descriptionText',
        confirmHeader: 'envelope.responsible.confirm-delete-modal.headerText',
        confirmQuestion: 'envelope.responsible.confirm-delete-modal.questionText',
        confirmMessage: 'envelope.responsible.confirm-delete-modal.messageText',
        showSsn: LanguageUtil.isCurrentLanguagePT(this.translateService.currentLang),
        showTelephone: this.isSendWhatsapp,
        showSignatureType: false,
        showSubscriberType: false,
        search: () => this.searchSignatories(this.searchText, null),
      },
    };

    this.config = configMap[this.participantTypeInput];

    if (this.config) {
      this.titleModal = this.config.title;
      this.subTitle = this.config.subtitle;
      this.headerTextConfirmDeleteModal = this.config.confirmHeader;
      this.questionTextConfirmDeleteModal = this.config.confirmQuestion;
      this.messageTextConfirmDeleteModal = this.config.confirmMessage;
      this.showSSN = this.config.showSsn;
      this.showTelephone = this.config.showTelephone;
      this.showSignatureType = this.config.showSignatureType;
      this.showSubscriberType = this.config.showSubscriberType;
      this.config.search();

      if ('analytics' in this.config) {
        this.config.analytics();
      }
    }
  }

  modalClose() {
    this.closeModalClick.emit();
  }

  modalSubmit() {
    this.submitModalClick.emit({ data: this.elementsSelecteds, isEdited: false });
  }

  onTableChange(selecteds) {
    this.elementsSelecteds = [];

    this.elements.forEach(obj => {
      const isSelected = selecteds.includes(obj.id);
      obj.checked = isSelected;

      if (isSelected) {
        this.elementsSelecteds.push(obj);
      }
    });
  }

  buttonsHeaderAddClick() {
    this.userToEditSignatory = null;
    this.userToEditAuthorizer = null;
    this.userToEditObserver = null;
    this.userToEditResponsible = null;

    const modalMap = {
      [ParticipantTypeEnum.Signatory]: this.addSignatoryModal,
      [ParticipantTypeEnum.Authorizer]: this.addAuthorizerModal,
      [ParticipantTypeEnum.Observer]: this.addObserverModal,
      [ParticipantTypeEnum.Responsible]: this.addResponsibleModal,
    };

    const modalContent = modalMap[this.participantTypeInput];

    if (modalContent) {
      this.activeModal = this.modalService.open(modalContent, {
        size: 'lg',
        scrollable: false,
        backdropClass: 'override-backdrop',
      });
    }
  }

  addSignatoryToTable(sign: Signatory) {
    if (this.isTemporary(sign.id)) {
      this.submitModalClick.emit({ data: sign, isEdited: false });
      return;
    }
    this.searchSignatories(this.searchText, sign);
    this.userToEditSignatory = null;
  }

  addAuthorizerToTable(user: Authorizer) {
    this.searchSignatories(this.searchText, user);
    this.userToEditSignatory = null;
  }

  addObserverToTable(user: Observer) {
    this.searchSignatories(this.searchText, user);
    this.userToEditSignatory = null;
  }

  addResponsibleToTable(user: Responsible) {
    this.searchSignatories(this.searchText, user);
    this.userToEditSignatory = null;
  }

  onTableScroll() {
    this.pageSize++;
    this.filter.skip = this.getSkipFilter();
    this.filter.take = this.getTakeFilter();
    this.config.search();
  }

  private getSkipFilter() {
    return this.pageSize * this.pageLimit;
  }

  private getTakeFilter() {
    return this.pageLimit;
  }

  search(value) {
    this.filter.skip = 0;
    this.filter.take = 100;
    this.pageSize = 0;
    this.pageLimit = 100;
    this.searchSignatories(value, null);
  }

  showConfirmationDelete(ids) {
    this.userToEditAuthorizer = null;
    this.userToEditObserver = null;
    this.userToEditResponsible = null;
    this.idsToRemove = ids;

    this.activeModal = this.modalService.open(this.confirmDeleteModal, {
      size: 'md',
      scrollable: false,
      backdropClass: 'override-backdrop',
    });
  }

  fillForm(id) {
    this.layoutService.toggleLoading(true);

    const configMap = {
      [ParticipantTypeEnum.Signatory]: {
        modal: this.addSignatoryModal,
        setUser: (user) => (this.userToEditSignatory = user),
      },
      [ParticipantTypeEnum.Authorizer]: {
        modal: this.addAuthorizerModal,
        setUser: (user) => (this.userToEditAuthorizer = user),
      },
      [ParticipantTypeEnum.Observer]: {
        modal: this.addObserverModal,
        setUser: (user) => (this.userToEditObserver = user)
      },
      [ParticipantTypeEnum.Responsible]: {
        modal: this.addResponsibleModal,
        setUser: (user) => (this.userToEditResponsible = user)
      },
    };

    const config = configMap[this.participantTypeInput];
    if (!config) return;

    const selected = this.elements.find((el) => el.id == id);
    config.setUser(selected);

    this.activeModal = this.modalService.open(config.modal, {
      size: 'lg',
      scrollable: false,
      backdropClass: 'override-backdrop',
    });
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  confirmModalYesClick() {
    this.loading = true;
    this.activeModal.close();
    let lstToInactive;

    const inactiveParticipant = (
      elements: any[],
      service: any,
      searchFn: (searchText: string, filter: any) => void,
      resetSelected: any[]
    ) => {
      lstToInactive = elements.filter(obj => this.idsToRemove.includes(obj.id));
      service.inactiveMany(lstToInactive.map((x) => x.id)).then(() => {
        resetSelected.length = 0;
        this.elements = this.elements.filter(
          el => !this.idsToRemove.includes(el.id)
        );
        searchFn(this.searchText, null);
      });
    };
    inactiveParticipant(
      this.elements,
      this.signatoryService,
      this.searchSignatories.bind(this),
      this.elementsSelecteds
    );
  }

  closeCreateSignatoryModal() {
    this.activeModal.dismiss();
    this.loading = false;
  }

  addOrDeleteElementSelected(element) {
    const participantConfig = {
      [ParticipantTypeEnum.Signatory]: {
        table: this.tableUser,
        type: 'signatory' as const,
      },
      [ParticipantTypeEnum.Authorizer]: {
        table: this.tableAuthorizerUser,
        type: 'authorizer' as const,
      },
      [ParticipantTypeEnum.Observer]: {
        table: this.tableObserverUser,
        type: 'observer' as const,
      },
      [ParticipantTypeEnum.Responsible]: {
        table: this.tableResponsibleUser,
        type: 'responsible' as const,
      },
    };

    const selectedList = this.elementsSelecteds;

    const participant = participantConfig[this.participantTypeInput];

    if (participant) {
      let index = selectedList.findIndex(
        (el) => el.id === element.id
      );

      if (index >= 0) {
        selectedList.splice(index, 1);
      }

      if (element.checked) {
        selectedList.push(element);
      }

      if (participant.type === 'signatory') {
        this.tableUser.addListSelecteds(
          this.elementsSelecteds as Signatory[]
        );
      } else if (participant.type === 'authorizer') {
        this.tableAuthorizerUser.addListSelecteds(
          this.elementsSelecteds as Authorizer[]
        );
      } else if (participant.type === 'observer') {
        this.tableObserverUser.addListSelecteds(
          this.elementsSelecteds as Observer[]
        );
      } else if (participant.type === 'responsible') {
        this.tableResponsibleUser.addListSelecteds(
          this.elementsSelecteds as Responsible[]
        );
      }
    }
  }

  //#region PRIVATE
  private searchSignatories(value, sign) {
    const participantConfig = {
      [ParticipantTypeEnum.Signatory]: {
        table: this.tableUser,
        type: 'signatory' as const,
        tableUser: TableSignUser
      },
      [ParticipantTypeEnum.Authorizer]: {
        table: this.tableAuthorizerUser,
        type: 'authorizer' as const,
        tableUser: TableAuthorizerUser
      },
      [ParticipantTypeEnum.Observer]: {
        table: this.tableObserverUser,
        type: 'observer' as const,
        tableUser: TableObserverUser
      },
      [ParticipantTypeEnum.Responsible]: {
        table: this.tableResponsibleUser,
        type: 'responsible' as const,
        tableUser: TableResponsibleUser
      },
    };

    const participant = participantConfig[this.participantTypeInput];
    this.loading = true;
    this.searchText = value;
    this.filter.name = this.searchText;
    var signId = sign ? sign.id : null;
    var idx = -1;
    this.signatoryService
      .listActives(this.filter)
      .subscribe((data) => {
        this.loading = false;
        const signatoriesData = this.pageSize > 0 ? this.elements.concat(data) : data;
        const signatories = new Map<number, any>();

        this.elementsSelecteds.forEach(el => signatories.set(el?.id, { ...el, checked: true }));

        signatoriesData.forEach(el => {
          if (signId !== el.id) {
            const isSelected = this.elementsSelecteds.find(selected => selected.id === el.id);
            signatories.set(el.id, { ...el, checked: isSelected ? true : el.checked });
          }
        });

        this.elements = Array.from(signatories.values());

        if (sign !== null && sign.id) {
          idx = this.elements.findIndex(el => el.id === sign.id);
          let signatory;

          if (idx >= 0) {
            signatory = this.elements[idx];
            Object.assign(signatory, sign);
            signatory[participant.tableUser.propCheck] = true;
          } else {
            signatory = JSON.parse(JSON.stringify(sign));
            signatory[participant.tableUser.propCheck] = true;
            this.elements.unshift(signatory);
          }

          const displaySignatory = JSON.parse(JSON.stringify(signatory));
          displaySignatory.ssn = displaySignatory.ssn && CPFCNPJUtil.obfuscateCpfCnpj(displaySignatory.ssn) || "";
          
          const indexInElements = this.elements.findIndex(el => el.id === sign.id);
          if (indexInElements >= 0) {
            this.elements[indexInElements].ssnDisplay = displaySignatory.ssn;
          }

          if (!this.elementsSelecteds.includes(signatory)) {
            this.elementsSelecteds.push(signatory);
          }

          this.addOrDeleteElementSelected(signatory);
        }

        this.elementsSelecteds.forEach((element) => {
          const signatory = this.elements.find(
            (el) => el.id === element.id
          );

          if (signatory !== undefined) {
            signatory[participant.tableUser.propCheck] = true;
          }
        });

        if (sign !== null && sign && idx >= 0) {
          this.signatoryEdited = sign;
          this.submitModalClick.emit({ data: this.signatoryEdited, isEdited: true });
          this.signatoryEdited = [];
        }
      });
  }

  private isTemporary(id: any): boolean {
    return typeof id === 'string' && id.startsWith('temp-');
  }
  //#endregion
}
